import axiosClient from 'api/shared/AxiosClient';
class DataTrainingService {

    getNuMessageList = async () => {
        const resp = await axiosClient.get(
            `/data-training/messages_nu`);
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }
    }

    getNuMessageListWithPagination = async (limit, skip, search) => {
        const resp = await axiosClient.get(`/data-training/messages_nu/list?limit=${limit}&skip=${skip}&search=${search}`);
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }

    }


    getIntentList = async (language) => {
        return {
            horaires_fr: "[FR] Consultation des horaires et les tarifs ",
            apres_vente: "[FR] Service après-vente  ",
            autoservice_fr: "[FR] Service Train & Auto ",
            gare_proche_fr: "[FR] Trouver la gare de train la plus proche ",
            greet: "[FR] Saluer le bot  ",
            get_help: "[FR] Demander de l'aide au bot ",
            human_handover: "[FR] Contacter un commercial humain ",
            how_are_you: "[FR] Demander l’etat du bot  ",
            ok: "[FR] Confirmation ",
            askweather: "[FR] Poser des questions sur la météo ",
            tell_joke: "[FR] Demander des blagues au bot ",
            thankyou: "[FR] Remercier le bot ",
            bye: "[FR] Dire au revoir au bot ",
            insult: "[FR] Insulter le bot ",
            compliment: "[FR] Faire un compliment au bot ",
            change_lang_fr: "[FR] Changer la langue du bot ",
            horaires_ar: "[AR/DARIJA] Consultation des horaires et les tarifs ",
            apres_vente_ar: "[AR/DARIJA] Service après-vente",
            gare_proche_ar: "[AR/DARIJA] Trouver la gare de train la plus proche",
            autoservice_ar: "[AR/DARIJA] Service Train & Auto",
            greet_ar: "[AR/DARIJA] Saluer le bot",
            bot_id_ar: "[AR/DARIJA] Demander l’Identité du bot",
            change_lang_ar: "[AR/DARIJA] Changer la langue du bot",
            compliment_ar: "[AR/DARIJA] Faire un compliment au bot",
            help_ar: "[AR/DARIJA] Demander de l'aide au bot",
            howareyou_ar: "[AR/DARIJA] Demander l'etat du bot",
            human_ar: "[AR/DARIJA] Contacter un commercial humain",
            insult_ar: "[AR/DARIJA] insulter le bot",
            ok_ar: "[AR/DARIJA] Confirmation",
            thanks_ar: "[AR/DARIJA] Remercier le bot",
            user_love_ar: "[AR/DARIJA] Exprimer ses sentiments au bot",
            weather_ar: "[AR/DARIJA] Poser des questions sur la météo",
            bye_ar: "[AR/DARIJA] Dire au revoir au Bot",
            horaires_en: "[ENG] Consultation des horaires et les tarifs",
            apres_vente_eng: "[ENG] Service après-vente",
            train_auto_en: "[ENG] Service Train & Auto",
            station_en: "[ENG] Trouver la gare de train la plus proche",
            greet_en: "[ENG] Saluer le bot",
            get_help_en: "[ENG] Demander de l'aide au bot",
            human_handover_en: "[ENG] Contacter un commercial humain",
            how_are_you_en: "[ENG] Demander l’etat du bot",
            bot_id_en: "[ENG] Demander l’Identité du bot",
            change_lang_en: "[ENG] Changer la langue du bot",
            compliment_en: "[ENG] Faire un compliment au bot",
            insult_en: "[ENG] insulter le bot",
            ok_en: "[ENG] Confirmation",
            thanks_en: "[ENG] Remercier le bot",

        }
    }

    getUMessagesWithNewIntent = async () => {
        const resp = await axiosClient.get(
            `/data-training/messages_with_new_intent`
        );
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }
    }

    assignIntent = async (id, data) => {
        const resp = await axiosClient.post(
            `/data-training/messages_nu/${id}`, data);
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }
    }

    deleteIntent = async (id) => {
        const resp = await axiosClient.delete(
            `/data-training/messages_nu/${id}`);
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }
    }

    startTraining = async () => {
        const resp = await axiosClient.post(
            `/data-training/start_training`
        );
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }

    }

}

const dataTrainingService = new DataTrainingService();
export default dataTrainingService;
